import { SymbolType } from '../types/game.types';

export interface PaytableConfig {
    [key: string]: {
        3?: number;
        4?: number;
        5?: number;
    };
}

export const DEFAULT_PAYTABLE: PaytableConfig = {
    [SymbolType.TREASURE_CHEST]: { 3: 20, 4: 100, 5: 500 },
    [SymbolType.NEON_DIAMOND]: { 3: 15, 4: 80, 5: 400 },
    [SymbolType.SHOWGIRL_HAT]: { 3: 12, 4: 60, 5: 300 },
    [SymbolType.SPORTS_CAR]: { 3: 10, 4: 50, 5: 250 },
    [SymbolType.DICE]: { 3: 8, 4: 30, 5: 150 },
    [SymbolType.MARTINI]: { 3: 8, 4: 30, 5: 150 },
    [SymbolType.COINS]: { 3: 8, 4: 30, 5: 150 },
    [SymbolType.HORSESHOE]: { 3: 8, 4: 30, 5: 150 },
    [SymbolType.ACE]: { 3: 5, 4: 20, 5: 100 },
    [SymbolType.KING]: { 3: 5, 4: 20, 5: 100 },
    [SymbolType.QUEEN]: { 3: 5, 4: 20, 5: 100 },
    [SymbolType.JACK]: { 3: 5, 4: 20, 5: 100 },
    [SymbolType.TEN]: { 3: 5, 4: 20, 5: 100 },
    [SymbolType.WILD]: { 3: 20, 4: 100, 5: 500 },
    [SymbolType.SCATTER]: { 3: 2, 4: 10, 5: 50 }
};

export const PAYLINES_5x3 = [
    [[1, 0], [1, 1], [1, 2], [1, 3], [1, 4]],
    [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4]],
    [[2, 0], [2, 1], [2, 2], [2, 3], [2, 4]],
    [[0, 0], [1, 1], [2, 2], [1, 3], [0, 4]],
    [[2, 0], [1, 1], [0, 2], [1, 3], [2, 4]],
    [[1, 0], [0, 1], [0, 2], [0, 3], [1, 4]],
    [[1, 0], [2, 1], [2, 2], [2, 3], [1, 4]],
    [[0, 0], [0, 1], [1, 2], [0, 3], [0, 4]],
    [[2, 0], [2, 1], [1, 2], [2, 3], [2, 4]],
    [[1, 0], [2, 1], [1, 2], [0, 3], [1, 4]],
    [[1, 0], [0, 1], [1, 2], [2, 3], [1, 4]],
    [[0, 0], [1, 1], [1, 2], [1, 3], [0, 4]],
    [[2, 0], [1, 1], [1, 2], [1, 3], [2, 4]],
    [[0, 0], [1, 1], [0, 2], [1, 3], [0, 4]],
    [[2, 0], [1, 1], [2, 2], [1, 3], [2, 4]],
    [[1, 0], [1, 1], [0, 2], [1, 3], [1, 4]],
    [[1, 0], [1, 1], [2, 2], [1, 3], [1, 4]],
    [[0, 0], [2, 1], [2, 2], [2, 3], [0, 4]],
    [[2, 0], [0, 1], [0, 2], [0, 3], [2, 4]],
    [[0, 0], [2, 1], [0, 2], [2, 3], [0, 4]]
];